import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons/faExclamationCircle';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';

import { Tooltip } from 'ui-components/components/tooltip';

import style from './style.module.less';
import GetMarketplaceDisplayName from '../../../../components/data-driven-logo/get-marketplace-display-name';

const UnsupportedMarketplace = ({ marketplaceId = -1 }) => {
  const intl = useIntl();
  const displayName = GetMarketplaceDisplayName(marketplaceId);
  const name = intl.formatMessage(displayName, displayName.values);
  return (
    <div className={style['error-icon']}>
      <Tooltip
        position='bottom'
        text={
          <FormattedMessage
            defaultMessage='ShipStation no longer supports {name}. To hide this store, mark as inactive in the actions menu.'
            description='deprecated marketplace tooltip text'
            id='C5X+tk'
            values={{ name }}
          />
        }
      >
        <span>
          <FontAwesomeIcon className={style['error-icon']} icon={faExclamationCircle} />
        </span>
      </Tooltip>
    </div>
  );
};

UnsupportedMarketplace.propTypes = {
  marketplaceId: PropTypes.number,
};

export default UnsupportedMarketplace;
